export default "__VITE_ASSET__CH$yM4fs__"